import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {MediaGalleryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import GalleryImagesBox from "./GalleryImagesBox"

type Props = {
	data: MediaGalleryModuleType
}

const GalleryContainerSection = ({data}: Props) => {
	return (
		<ContainerWrapper>
			<Title content={data.title} fontWeight={600} size={"M"} />
			<Separator size={32} />
			<GalleryImagesBox data={data} />
		</ContainerWrapper>
	)
}

export default GalleryContainerSection
